import React, { useContext, useEffect, useState } from 'react';
import CSVComp from './CSVComp'
import app from '../authentication/firebaseStart';
import styled from 'styled-components';
import { Button } from '@zebra-fed/zds-react-desktop';
import { useTranslation } from "react-i18next";
import DescriptionIcon from '@material-ui/icons/Description';
import CloseIcon from '@material-ui/icons/Close';
import { AuthContext } from '../authentication/Auth';
import LinearProgress from '@material-ui/core/LinearProgress';
import { DataContext } from '../data/DataContext';
import Checkbox from '@material-ui/core/Checkbox';
import { SitesnApsConfigData } from '../components/SitesnApsConfig';
import CircularProgress from '@material-ui/core/CircularProgress';
import { SiteService } from '../Services/SiteService'
import CProgress from '../components/CProgress';
import { TimeZoneData } from '../data/tzTimeZoneList';
import {covertIPToNumber} from '../utils/SiteSession';
import {EOD_CATEGORIES, EOD_CATEGORIES_TYPE} from '../data/constants'
const CheckboxComp = styled.div`
    display: flex;
    align-items: center;
    margin-left: -8px;
    font-size: 20px;
`;

const ButtonContainer = styled.div`
    display: flex;
    max-width: 500px;
    justify-content: end;
`;

const CloseIconCustom = styled(CloseIcon)`
    margin-right: 5px;
    &:hover {
        cursor: pointer;
    }
`;

const LinearProgressStyled = styled(LinearProgress)`
    width: 100%;
`;
var allApsData = [];
var allDevData = [];

const firestore = app.firestore();

function selectProps(...props) {
    return function (obj) {
        const newObj = {};
        props.forEach((name) => {
            newObj[name] = obj[name];
        });

        return newObj;
    };
}

function CSVImport(props) {
    const { cancelClicked = () => { }, importType, ConfigData, isLoadingCsv, deviceRegistrationType,
        sitesData, apsData, devicesData, refreshPage = () => { }, hasUpdatedTime, } = props;
    let { globalAppSettings, setGlobalAppSettings } = useContext(DataContext);
    const [importedRecords, setImportedRecords] = useState([])
    const [importedApsRecords, setImportedApsRecords] = useState([])
    const [updatedMsg, setUpdatesMsg] = useState("")
    const [fileInfo, setFileInfo] = useState({})
    const [isParsed, setIsParsed] = useState(false)
    const [clearRecords, setClearRecords] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [isLoading2, setIsLoading2] = useState(false)
    const [isLoading3, setIsLoading3] = useState(false)
    const [errorMsg, setErrorMsg] = useState("incorrect file")
    const [dataUpdated, setDataUpdated] = useState(false)
    const context = useContext(AuthContext);
    const [totalCsvParts, setTotalCsvParts] = useState(0);
    const [totalApsCsvParts, setTotalApsCsvParts] = useState(0);
    const [totalDevicesCsvParts, setTotalDevicesCsvParts] = useState(0);
    const [totalApsSiteCsvParts, setTotalApsSiteCsvParts] = useState(0);
    const [totalSiteSiteCsvParts, setTotalSiteSiteCsvParts] = useState(0);
    const [currPercent, setCurrPercent] = useState(0)
    const [currApsPercent, setCurrApsPercent] = useState(0)
    const [currDevicesPercent, setCurrDevicesPercent] = useState(0)
    const [currApsSitePercent, setCurrApsSitePercent] = useState(0)
    const [currSiteSitePercent, setCurrSiteSitePercent] = useState(0)
    const { t } = useTranslation();
    const [sitesArr, setSitesArr] = useState([])
    const [matchedApsFromSites, setMatchedApsFromSites] = useState([])
    const [matchedDevicesFromSites, setMatchedDevicesFromSites] = useState([])
    const [accessInclude, setAccessInclude] = useState(false)
    const [matchedSiteFromAps, setMatchedSiteFromAps] = useState([])
    const [firebaseError, setFirebaseError] = useState(false)
    const [testApsData, setTestApsData] = useState([])
    const [testDevData, setTestDevData] = useState([])

    // DLR flag
    const { dlrFeatureFlag, mlPredictionStatus } = useContext(DataContext);

    useEffect(() => {
        if (dataUpdated) {
            setCurrPercent(0);
            setCurrApsPercent(0);
            setCurrDevicesPercent(0);
        }
    }, [dataUpdated])

    async function getCategories(inputCategories) {
        console.log('inputCategories ',inputCategories)

        let defaultCategoryList = [EOD_CATEGORIES_TYPE.DEFAULT]
        if(!inputCategories) return defaultCategoryList

        let inputCategoriesArr = inputCategories.split(",")
        let inputCategoriesArrInUpperCase = inputCategoriesArr.map(el => el.trim().toUpperCase())
        console.log('inputCategoriesArrInUpperCase in upper case ',inputCategoriesArrInUpperCase)

        if(inputCategories.length === 0){
            return defaultCategoryList
        }
        else if(inputCategoriesArrInUpperCase.includes('ALL')){
            return [EOD_CATEGORIES_TYPE.INCLUDE_ALL]
        }else{

            let preDefinedCategories = Object.keys(EOD_CATEGORIES)
            
            let finalCategoryList = []
            inputCategoriesArrInUpperCase.forEach(el => {
                if(preDefinedCategories.includes(el.toUpperCase())){
                    if(!(el.toUpperCase() == "AT RISK" && !dlrFeatureFlag)){
                        return finalCategoryList.push(EOD_CATEGORIES[el.toUpperCase()])
                    }
                }
            })
                        if(globalAppSettings.enableBTScannerTracking === false){
                let indexOfAccessory = finalCategoryList.indexOf(EOD_CATEGORIES[EOD_CATEGORIES["CONNECTED ACCESSORIES"].toUpperCase()]);
                console.log("indexOfAccessory",indexOfAccessory)
                removeItemFromArray(indexOfAccessory,finalCategoryList)
            }


            console.log('finalCategoryList ',finalCategoryList)
            return finalCategoryList.length === 0 ? defaultCategoryList : finalCategoryList
        }
    }

    function removeItemFromArray(indexOfAccessory,arr){
        if(indexOfAccessory >=0){
            arr.splice(indexOfAccessory,1)
        }
        return arr;  
    }


    function onImportDone(records, fileInfo) {
        setFileInfo(fileInfo);
    }

    function findPercentage(records, type) {
        // console.log('type :', type);
        // console.log('records :', records);

        let dataSplitLimit2 = type === 'DEVICES' ? 249 : 499;
        let convertedJson = records;
        const index = convertedJson.length;
        let count = 0;
        for (let i = 0; i < convertedJson.length; i++) {
            if ((i + 1) % dataSplitLimit2 === 0) {
                count = count + 1;
            }
        }
        if (!(index % dataSplitLimit2) == 0) {
            count = count + 1;
        }

        if (type === 'DEVICES') {
            setTotalDevicesCsvParts(count);
        } else if (type === 'APS') {
            setTotalApsCsvParts(count);
        } else if (type === 'APS&&SITE') {
            setTotalApsSiteCsvParts(count);
        } else if (type === 'SITE&&SITE') {
            setTotalSiteSiteCsvParts(count);
        } else {
            setTotalCsvParts(count);
        }
        // setTotalCsvParts(count);
    }

    async function importToFirestoreDevices(method) {

        let dataSplitLimit = 249;

        let convertedJson = testDevData;
        if (convertedJson.length > 0) {
            if (globalAppSettings.deviceRegistrationType === 1) {
                convertedJson = testApsData.filter(values => values.connectionState === 0)
            }
            else {
                convertedJson = testDevData;
            }
            try {
                let batch = firestore.batch();
                const index = convertedJson.length;
                var fakeIndex = 0;
                for (let i = 0; i < convertedJson.length; i++) {
                    const doc = convertedJson[i];

                    let docRef = firestore.collection("tenants")
                        .doc(context.currentUser.claims.companyID)
                        .collection('Devices')
                        .doc(doc.modelNumber + '_' + doc.serialNumber);

                    var montiorRef = firestore.collection("tenants")
                        .doc(context.currentUser.claims.companyID)
                        .collection('Devices')
                        .doc(doc.modelNumber + '_' + doc.serialNumber)
                        .collection('Monitor')
                        .doc('Assignment')

                    batch.update(docRef, {
                        "siteName": "",
                        "displaySiteName": ""
                    })

                    batch.update(montiorRef, {
                        "siteName": "",
                        "displaySiteName": ""
                    })

                    if ((i + 1) % dataSplitLimit === 0) {
                        fakeIndex = fakeIndex + 1;
                        if (totalDevicesCsvParts > 0)
                            setCurrDevicesPercent(Math.round((fakeIndex / totalDevicesCsvParts) * 100));
                        await batch.commit()
                        batch = firestore.batch();
                    }
                }
                // For committing final batch
                if (!(index % dataSplitLimit) == 0) {
                    fakeIndex = fakeIndex + 1;
                    if (totalDevicesCsvParts > 0)
                        setCurrDevicesPercent(Math.round((fakeIndex / totalDevicesCsvParts) * 100));
                    await batch.commit()
                }
                let companyID = context.currentUser.claims.companyID;
                try {
                    if (hasUpdatedTime) {
                        await firestore
                            .collection('tenants')
                            .doc(companyID)
                            .collection('Configuration')
                            .doc('UpdatedTime')
                            .update({
                                siteInfoUpdated: Date.now()
                            })
                    } else {
                        await firestore
                            .collection('tenants')
                            .doc(companyID)
                            .collection('Configuration')
                            .doc('UpdatedTime')
                            .set({
                                siteInfoUpdated: Date.now()
                            })
                    }
                } catch (error) {
                    setFirebaseError(true);
                    console.log(error, 'error in importToFirestoreDevices')
                }
                importToFirestoreApsUpdate(importType?.value);
            } catch (error) {
                setFirebaseError(true);
                console.log(error, 'error 2 in importToFirestoreDevices')
            }
        } else {
            setCurrDevicesPercent(100);
            importToFirestoreApsUpdate(importType?.value);
        }
    }

    async function importToFirestoreApsUpdate(method) {

        let dataSplitLimit = 499;

        let convertedJson = accessInclude ? importedApsRecords : testApsData;
        if (convertedJson.length > 0) {
            try {
                let batch = firestore.batch();
                const index = convertedJson.length;
                var fakeIndex = 0;
                for (let i = 0; i < convertedJson.length; i++) {
                    const doc = convertedJson[i];

                    let apsRef = firestore.collection("tenants")
                        .doc(context.currentUser.claims.companyID)
                        .collection('Aps')
                        .doc(accessInclude ?
                            doc.BSSID.toUpperCase()
                            :
                            doc.apMacAddress);

                    (method === 'DELETE' && accessInclude) ? batch.delete(apsRef) : batch.update(apsRef, {
                        "siteName": "",
                        "displaySiteName": ""
                    });

                    if ((i + 1) % dataSplitLimit === 0) {
                        fakeIndex = fakeIndex + 1;
                        if (totalApsCsvParts > 0)
                            setCurrApsPercent(Math.round((fakeIndex / totalApsCsvParts) * 100));
                        await batch.commit()
                        batch = firestore.batch();
                    }
                }
                // For committing final batch
                if (!(index % dataSplitLimit) == 0) {
                    fakeIndex = fakeIndex + 1;
                    if (totalApsCsvParts > 0)
                        setCurrApsPercent(Math.round((fakeIndex / totalApsCsvParts) * 100));
                    await batch.commit()
                }
                let companyID = context.currentUser.claims.companyID;
                try {
                    if (hasUpdatedTime) {
                        await firestore
                            .collection('tenants')
                            .doc(companyID)
                            .collection('Configuration')
                            .doc('UpdatedTime')
                            .update({
                                siteInfoUpdated: Date.now()
                            })
                    } else {
                        await firestore
                            .collection('tenants')
                            .doc(companyID)
                            .collection('Configuration')
                            .doc('UpdatedTime')
                            .set({
                                siteInfoUpdated: Date.now()
                            })
                    }
                } catch (error) {
                    setFirebaseError(true);
                    console.log(error, 'error in importToFirestoreApsUpdate')
                }
                importToFirestoreSiteLocations('DELETE')
            } catch (error) {
                setFirebaseError(true);
                console.log(error, 'error 2 in importToFirestoreApsUpdate')
            }
        } else {
            setCurrApsPercent(100);
            importToFirestoreSiteLocations('DELETE');
        }


    }
    const service = new SiteService();

    async function importToFirestoreSiteLocations(method) {

        let dataSplitLimit = 499;
        let convertedJson = importedRecords;
        
        try {
            let batch = firestore.batch();
            const index = convertedJson.length;
            let fakeIndex = 0;
            for (let i = 0; i < convertedJson.length; i++) {
                const doc = convertedJson[i];
                let categoriesArr = await getCategories(doc.snapshotReportCategories)
                let categoriesStr = categoriesArr.join(",")
                console.log("categoriesStr ===== ",categoriesStr)

                var sitesRef = firestore.collection("tenants")
                    .doc(context.currentUser.claims.companyID)
                    .collection('SiteLocations')
                    .doc(doc.SiteName.toUpperCase());
                if (method === 'DELETE') {
                    batch.delete(sitesRef)
                }
                else {
                    let correctTimezone = TimeZoneData.filter(values => values?.tzDatabaseName?.toUpperCase() === doc?.timeZone?.toUpperCase());
                    let splited = doc.scheduledReportTime.split(' ')
                    let utcTime = service.getUTCTime(doc.timeZone, splited[1], splited[0])
                    if (method === 'MODIFY') {
                        batch.update(sitesRef, {
                            "timeZone": correctTimezone[0].tzDatabaseName,
                            "scheduledReportTime": doc.scheduledReportTime,
                            "emailSubscribed": doc.EmailSubscribed,
                            "emailList": doc.emailList,
                            "siteName": doc.SiteName.toUpperCase(),
                            "displaySiteName": doc.SiteName,
                            "lastUpdatedAt": Date.now(),
                            "siteApsUpdated": Date.now(),
                            "reportHoursActual":doc.scheduledReportTime?parseInt(splited[1]):null,
                            "reportMinutesActual":doc.scheduledReportTime?parseInt(splited[0]):null,
                            "reportUTCHours": utcTime.hr,
                            "reportUTCMinutes": utcTime.min,
                            "dstObserved": doc?.dstObserved,
                            "startIPAddress":doc.startIPAddress?doc.startIPAddress:"",
                            "endIPAddress":doc.endIPAddress?doc.endIPAddress:"",
                            "startIPAsNum":covertIPToNumber(doc.startIPAddress?doc.startIPAddress:0),
                            "endIPAsNum":covertIPToNumber(doc.endIPAddress?doc.endIPAddress:0),
                            "snapshotReportCategories" : categoriesStr,
                            "attachCSV" : doc.attachCSV ? doc.attachCSV : false
                        })
                    }
                    else {
                        batch.set(sitesRef, {
                            "timeZone": correctTimezone[0].tzDatabaseName,
                            "scheduledReportTime": doc.scheduledReportTime,
                            "emailSubscribed": doc.EmailSubscribed,
                            "emailList": doc.emailList,
                            "siteName": doc.SiteName.toUpperCase(),
                            "displaySiteName": doc.SiteName,
                            "lastUpdatedAt": Date.now(),
                            "siteApsUpdated": Date.now(),
                            "reportUTCHours": utcTime.hr,
                            "reportUTCMinutes": utcTime.min,
                            "reportHoursActual":doc.scheduledReportTime?parseInt(splited[1]):null,
                            "reportMinutesActual":doc.scheduledReportTime?parseInt(splited[0]):null,
                            "dstObserved": doc?.dstObserved,
                            "startIPAddress": doc.startIPAddress ? doc.startIPAddress : "",
                            "endIPAddress": doc.endIPAddress ? doc.endIPAddress : "",
                            "startIPAsNum": doc.startIPAddress ? covertIPToNumber(doc.startIPAddress) : 0 ,
                            "endIPAsNum": doc.endIPAddress ? covertIPToNumber(doc.endIPAddress) : 0,
                            "snapshotReportCategories" : categoriesStr,
                            "attachCSV" : doc.attachCSV ? doc.attachCSV : false
                        });
                    }
                }

                if ((i + 1) % dataSplitLimit === 0) {
                    fakeIndex = fakeIndex + 1;
                    if (totalCsvParts > 0)
                        setCurrPercent(Math.round((fakeIndex / totalCsvParts) * 100));
                    await batch.commit()
                    batch = firestore.batch();
                }
            }
            // For committing final batch
            if (!(index % dataSplitLimit) == 0) {
                fakeIndex = fakeIndex + 1;
                if (totalCsvParts > 0)
                    setCurrPercent(Math.round((fakeIndex / totalCsvParts) * 100));
                await batch.commit()
            }
            let companyID = context.currentUser.claims.companyID;
            try {
                if (hasUpdatedTime) {
                    await firestore
                        .collection('tenants')
                        .doc(companyID)
                        .collection('Configuration')
                        .doc('UpdatedTime')
                        .update({
                            siteInfoUpdated: Date.now()
                        })
                } else {
                    await firestore
                        .collection('tenants')
                        .doc(companyID)
                        .collection('Configuration')
                        .doc('UpdatedTime')
                        .set({
                            siteInfoUpdated: Date.now()
                        })
                }
            } catch (error) {
                setFirebaseError(true);
                console.log(error, 'error in importToFirestoreSiteLocations')
            }
            if (accessInclude && importType?.value === 'ADD') {
                importToFirestoreApsSite('ADD');
            } else {
                setIsLoading(false);
                setDataUpdated(true);
                setCurrPercent(0);
            }
        } catch (error) {
            setFirebaseError(true);
            console.log(error, 'error 2 in importToFirestoreSiteLocations')
        }

    }

    async function importToFirestoreApsSite(method) {
        let dataSplitLimit = 499;
        let convertedJson = importedApsRecords;
        try {
            let batch = firestore.batch();
            const index = convertedJson.length;
            var fakeIndex = 0;
            for (let i = 0; i < convertedJson.length; i++) {
                const doc = convertedJson[i];
                // await new Promise(r => setTimeout(r, 0.1));

                var accessRef = firestore.collection("tenants")
                    .doc(context.currentUser.claims.companyID)
                    .collection('Aps')
                    .doc(doc.BSSID.toUpperCase());

                method === 'DELETE' ? batch.delete(accessRef) :
                    method === 'MODIFY' ?
                        batch.update(accessRef, {
                            "apMacAddress": doc.BSSID.toUpperCase(),
                            "displayApMacAddress": doc.BSSID,
                            "apAssetName": doc.AssetName,
                            "apFriendlyName": doc.LocationFriendlyName.toUpperCase(),
                            "displayAPFriendlyName": doc.LocationFriendlyName,
                            "siteName": doc.SiteName.toUpperCase(),
                            "displaySiteName": doc.SiteName,
                            "lastUpdatedAt": Date.now()

                        })
                        :
                        batch.set(accessRef, {
                            "apMacAddress": doc.BSSID.toUpperCase(),
                            "displayApMacAddress": doc.BSSID,
                            "apAssetName": doc.AssetName,
                            "apFriendlyName": doc.LocationFriendlyName.toUpperCase(),
                            "displayAPFriendlyName": doc.LocationFriendlyName,
                            "siteName": doc.SiteName.toUpperCase(),
                            "displaySiteName": doc.SiteName,
                            "lastUpdatedAt": Date.now()

                        });

                if ((i + 1) % dataSplitLimit === 0) {
                    fakeIndex = fakeIndex + 1;
                    setCurrApsSitePercent(Math.round((fakeIndex / totalApsSiteCsvParts) * 100));
                    await batch.commit()
                    batch = firestore.batch();
                }
            }
            // For committing final batch
            if (!(index % dataSplitLimit) == 0) {
                fakeIndex = fakeIndex + 1;
                setCurrApsSitePercent(Math.round((fakeIndex / totalApsSiteCsvParts) * 100));
                await batch.commit()
            }
            let companyID = context.currentUser.claims.companyID;
            try {
                if (hasUpdatedTime) {
                    await firestore
                        .collection('tenants')
                        .doc(companyID)
                        .collection('Configuration')
                        .doc('UpdatedTime')
                        .update({
                            siteInfoUpdated: Date.now()
                        })
                } else {
                    await firestore
                        .collection('tenants')
                        .doc(companyID)
                        .collection('Configuration')
                        .doc('UpdatedTime')
                        .set({
                            siteInfoUpdated: Date.now()
                        })
                }
            } catch (error) {
                setFirebaseError(true);
            }
            if (matchedSiteFromAps.length > 0) {
                importToFirestoreApsSiteLocationsSiteUpdate();
            } else {
                setIsLoading(false);
                setDataUpdated(true);
            }
        } catch (error) {
            setFirebaseError(true);
        }
    }

    async function importToFirestoreApsSiteLocationsSiteUpdate(method) {

        let dataSplitLimit = 499;
        let convertedJson = matchedSiteFromAps;
        try {
            let batch = firestore.batch();
            const index = convertedJson.length;
            var fakeIndex = 0;
            for (let i = 0; i < convertedJson.length; i++) {
                const doc = convertedJson[i];
                // await new Promise(r => setTimeout(r, 0.1));

                let sitesRef = firestore.collection("tenants")
                    .doc(context.currentUser.claims.companyID)
                    .collection('SiteLocations')
                    .doc(doc.toUpperCase());

                batch.update(sitesRef, {
                    "siteApsUpdated": Date.now()
                });


                if ((i + 1) % dataSplitLimit === 0) {
                    fakeIndex = fakeIndex + 1;
                    setCurrSiteSitePercent(Math.round((fakeIndex / totalSiteSiteCsvParts) * 100));
                    await batch.commit()
                    batch = firestore.batch();
                }
            }
            // For committing final batch
            if (!(index % dataSplitLimit) == 0) {
                fakeIndex = fakeIndex + 1;
                setCurrSiteSitePercent(Math.round((fakeIndex / totalSiteSiteCsvParts) * 100));
                await batch.commit()
            }
            let companyID = context.currentUser.claims.companyID;
            try {
                if (hasUpdatedTime) {
                    await firestore
                        .collection('tenants')
                        .doc(companyID)
                        .collection('Configuration')
                        .doc('UpdatedTime')
                        .update({
                            siteInfoUpdated: Date.now()
                        })
                } else {
                    await firestore
                        .collection('tenants')
                        .doc(companyID)
                        .collection('Configuration')
                        .doc('UpdatedTime')
                        .set({
                            siteInfoUpdated: Date.now()
                        })
                }
            } catch (error) {
                setFirebaseError(true);
            }
            setIsLoading(false);
            setDataUpdated(true);
        } catch (error) {
            setFirebaseError(true);
        }
    }

    function handleCancel(value) {
        value === 'DISMISS' && refreshPage();
        cancelClicked();
        setIsParsed(false)
        setImportedRecords([])
        setClearRecords(true)
        setDataUpdated(false)
        setIsLoading(false);
        setIsLoading2(false);
        setAccessInclude(false);
        setFirebaseError(false);
    }

    const onClickContinueBtn = () => {
        setIsLoading(true);
        if (importType?.value === 'DELETE') {
            importToFirestoreDevices(importType?.value);
        } else {
            importToFirestoreSiteLocations(importType?.value);
        }
    }

    const onParsingStart = (value) => {
        if (value) {
            setIsLoading2(true);
            importType?.value === 'DELETE' && setIsLoading3(true);

        }
    }

    const getAllDataOnlyDevices = async (lastReported, sitee, siteArr) => {
        let companyID = context.currentUser.claims.companyID;

        if (sitee) {
            // setIsLoading2(true)

            let Query;
            Query = firestore.collection("tenants")
                .doc(companyID)
                .collection('Devices')
                .where('siteName', '==', sitee.toUpperCase())
                .orderBy('reportedAt', 'desc')

            if (lastReported != null) { Query = Query.startAfter(lastReported) }
            const snapshot = (await Query.limit(4000).get());
            let snapshotData = snapshot.docs.map((doc) => doc.data());
            allDevData = allDevData.concat(snapshotData)
            // snapshot.length > 0 && findPercentage(allDevData, 'DEVICES');

            setTestDevData(allDevData)
            lastReported = snapshotData[snapshotData.length - 1]?.reportedAt;
            if (snapshotData.length === 0) {
                setIsLoading3(false);
                findPercentage(allDevData, 'DEVICES');
                // findPercentage(testDevData, 'DEVICES');
                // siteArr.map((vva) => {
                //     // setIsLoading2(true)
                //     getAllDataOnlyAps('lastReported', vva);
                //     // getAllDataOnlyDevices('lastReported', vva);
                // })
                return
            }
            getAllDataOnlyDevices(lastReported)

        }

    }

    const getAllDataOnlyAps = async (lastReported, sitee, siteArr) => {
        let companyID = context.currentUser.claims.companyID;

        if (sitee) {
            // setIsLoading2(true)
            let Query;
            Query = firestore.collection("tenants")
                .doc(companyID)
                .collection('Aps')
                .where('siteName', '==', sitee.toUpperCase())
                .orderBy('apMacAddress', 'desc')

            if (lastReported != null) { Query = Query.startAfter(lastReported) }
            const snapshot = (await Query.limit(4000).get());
            let snapshotData = snapshot.docs.map((doc) => doc.data());
            allApsData = allApsData.concat(snapshotData)
            // snapshot.length > 0 && findPercentage(allApsData, 'DEVICES');
            setTestApsData(allApsData)
            lastReported = snapshotData[snapshotData.length - 1]?.apMacAddress;
            if (snapshotData.length === 0) {
                setIsLoading2(false)
                // findPercentage(testApsData, 'APS');
                // if ( siteArr.length > 0) {
                //     findPercentage(allApsData, 'DEVICES');

                // siteArr.map((vva) => {
                //     // setIsLoading2(true)
                //     getAllDataOnlyDevices('lastReported', vva);
                //     // getAllDataOnlyDevices('lastReported', vva);
                // })
                // }

                return
            }
            getAllDataOnlyAps(lastReported)

        }

    }


    const onParsingComplete = (results, records, siteMatchedAps, siteMatchedDevices, SitesMatchedfromAps) => {


        if (importType?.value === 'DELETE') {
            let getSiteFromRec = [...new Set(records.map(val => val.SiteName))]
            getSiteFromRec.push("LAST_ELEM")
            // console.log('records :', records.map(val => val.SiteName));
            getSiteFromRec.forEach((ele) => {
                // setIsLoading2(true)
                getAllDataOnlyAps('lastReported', ele);
                getAllDataOnlyDevices('lastReported', ele);
            })
        }

        if (accessInclude) {
            let sitesJsonData = records?.map(selectProps("SiteName", "timeZone", 'scheduledReportTime', 'EmailSubscribed', 'emailList', 'reportUTCHours', 'reportUTCMinutes', 'dstObserved'));
            let apsJsonData = records?.map(selectProps("SiteName", "BSSID", "AssetName", 'LocationFriendlyName'));
            let sitesNames = [...new Set(records.map(val => val.SiteName))]
            setImportedRecords(sitesJsonData);

            // setMatchedApsFromSites(siteMatchedAps);
            // setMatchedDevicesFromSites(siteMatchedDevices);

            setImportedApsRecords(apsJsonData);
            findPercentage(records);
            // findPercentage(testApsData, 'APS');
            // findPercentage(testDevData, 'DEVICES');
            setMatchedSiteFromAps(sitesNames);
            findPercentage(apsJsonData, 'APS&&SITE');
            findPercentage(SitesMatchedfromAps, 'SITE&&SITE');
        }

        else
            if (!accessInclude && records?.length > 0) {
                setImportedRecords(records);
                findPercentage(records);
            } else {
                setImportedRecords([])
            }
        setIsParsed(true)
        setClearRecords(false)
        if (importType && importType.value !== 'DELETE') {
            setIsLoading2(false)
        }
    }

    const onClickXButton = () => {
        setIsParsed(false)
        setClearRecords(true)
    }


    return (
        <div>
            <span style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                {
                    firebaseError ?
                        <p>Error Occured. Please retry</p>
                        :
                        isLoading ?
                            <>
                                {importType?.value === 'DELETE' ?
                                    <span style={{
                                        width: '100%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <div style={{ display: 'flex', border: '2px solid gainsboro', alignItems: 'center', width: '230px', justifyContent: 'space-between', padding: '5px' }}>
                                            <span style={{ display: 'flex', alignItems: 'center' }}>
                                                <DescriptionIcon style={{ fontSize: '35px' }} />
                                                <span>
                                                    <p style={{ margin: '0px', fontSize: '14px' }}>{fileInfo?.name?.length > 20 ? fileInfo?.name?.substring(0, 20) + ".." : fileInfo?.name}</p>
                                                    <p style={{ margin: '0px', fontSize: '12px' }}>{fileInfo?.size}</p>
                                                </span>
                                            </span>
                                        </div>
                                        <CProgress percent={(Math.round((currDevicesPercent / 3) + (currApsPercent / 3) + (currPercent / 3)))} />
                                     

                                    </span>
                                    : accessInclude && importType?.value !== 'DELETE' ?

                                        <span style={{
                                            width: '100%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            <div style={{ display: 'flex', border: '2px solid gainsboro', alignItems: 'center', width: '230px', justifyContent: 'space-between', padding: '5px' }}>
                                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                                    <DescriptionIcon style={{ fontSize: '35px' }} />
                                                    <span>
                                                        <p style={{ margin: '0px', fontSize: '14px' }}>{fileInfo?.name?.length > 20 ? fileInfo?.name?.substring(0, 20) + ".." : fileInfo?.name}</p>
                                                        <p style={{ margin: '0px', fontSize: '12px' }}>{fileInfo?.size}</p>
                                                    </span>
                                                </span>
                                            </div>
                                            <CProgress percent={(Math.round(currPercent / 2) + (currApsSitePercent / 2))} />
                                
                                            <p style={{ marginLeft: '10px', position: 'absolute', right: '112px', fontSize: '13px' }}>{Math.round((currPercent / 2) + (currApsSitePercent / 2))}%</p>
                                        </span>
                                        :
                                        <span style={{
                                            width: '100%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            <div style={{ display: 'flex', border: '2px solid gainsboro', alignItems: 'center', width: '230px', justifyContent: 'space-between', padding: '5px' }}>
                                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                                    <DescriptionIcon style={{ fontSize: '35px' }} />
                                                    <span>
                                                        <p style={{ margin: '0px', fontSize: '14px' }}>{fileInfo?.name?.length > 20 ? fileInfo?.name?.substring(0, 20) + ".." : fileInfo?.name}</p>
                                                        <p style={{ margin: '0px', fontSize: '12px' }}>{fileInfo?.size}</p>
                                                    </span>
                                                </span>
                                            </div>
                                            <CProgress percent={currPercent} />
                                        </span>
                                }
                            </>
                            :
                            dataUpdated ?
                                <>
                                    {importType?.value === 'ADD' ?
                                        <p>Site data saved successfully to database</p>
                                        : importType?.value === 'MODIFY' ?
                                            <p>Site data modified successfully in database</p>
                                            : <p>Site data deleted successfully from database</p>
                                    }
                                </>
                                :
                                (!isLoading2 && !isLoading3) && importedRecords.length > 0 && isParsed ?
                                    <div style={{ display: 'flex', border: '2px solid gainsboro', alignItems: 'center', width: '230px', justifyContent: 'space-between', padding: '5px' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                            <DescriptionIcon style={{ fontSize: '35px' }} />
                                            <span>
                                                <p style={{ margin: '0px', fontSize: '14px' }}>{fileInfo?.name?.length > 20 ? fileInfo?.name?.substring(0, 20) + ".." : fileInfo?.name}</p>
                                                <p style={{ margin: '0px', fontSize: '12px' }}>{fileInfo?.size}</p>
                                            </span>
                                        </span>
                                        <CloseIconCustom onClick={onClickXButton} />

                                    </div>
                                    :
                                    <span style={{ flexDirection: 'column' }}>
                                        <CSVComp
                                            onImportDone={onImportDone}
                                            onParsingComplete={onParsingComplete}
                                            onParsingStart={onParsingStart}
                                            clearRecords={clearRecords}
                                            errorMsg={errorMsg}
                                            isLoading2={
                                                importType?.value !== 'DELETE' ?
                                                    isLoading2
                                                    : !isLoading2 && !isLoading3 ? false : true


                                                // return true
                                            }
                                            setIsLoading2={setIsLoading2}
                                            // isLoading3={isLoading3}
                                            ConfigData={accessInclude ? SitesnApsConfigData : ConfigData}
                                            sitesData={sitesData}
                                            apsData={apsData}
                                            devicesData={devicesData}
                                            importType={importType}
                                            includeAps={accessInclude}
                                            isLoadingCsv={isLoadingCsv}
                                            deviceRegistrationType={deviceRegistrationType}
                                            setClearRecords={setClearRecords}
                                        />
                                        {/* {!isLoadingCsv && 
                            <CheckboxComp>
                            <Checkbox
                                    checked={accessInclude}
                                    onChange={(e) => setAccessInclude(e.target.checked)}
                                />
                                <p style={{fontSize: '12px'}}>Include Access Points</p>
                            </CheckboxComp> } */}
                                    </span>
                }

            </span>

            <ButtonContainer>
                {
                    firebaseError ?
                        <Button
                            onClick={() => handleCancel('DISMISS')}
                            type="primary"
                            style={{ marginLeft: '0px' }}
                        >
                            {t('dismiss')}
                        </Button>
                        :
                        dataUpdated ?
                            <Button
                                onClick={() => handleCancel('DISMISS')}
                                type="primary"
                                style={{ marginLeft: '0px' }}
                                disabled={!importedRecords.length > 0}
                            >
                                {t('dismiss')}
                            </Button>
                            :
                            <>
                                {!isLoadingCsv &&
                                    <>
                                        <Button
                                            onClick={() => handleCancel()}
                                            type="primary"
                                            style={{ marginLeft: '0px', background: 'white', color: 'black', border: '2px solid gray' }}
                                        >
                                            {t('cancel')}
                                        </Button>
                                        <Button
                                            onClick={() => onClickContinueBtn()}
                                            type="primary"
                                            style={{ marginLeft: '0px' }}
                                            disabled={!importedRecords.length > 0 || isLoading}
                                        >
                                            {t('import')}
                                        </Button>
                                    </>}
                            </>
                }
            </ButtonContainer>
        </div>
    )
}

export default CSVImport;